import { HorizontalContainer, OverlayIconButton } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type ZoomControlsProps = {
    zoom: number;
    minZoom: number;
    maxZoom: number;
    onZoomIn: () => void;
    onZoomOut: () => void;
};

export const ZoomControls = ({
    zoom,
    minZoom,
    maxZoom,
    onZoomIn,
    onZoomOut,
}: ZoomControlsProps) => (
    <HorizontalContainer spacing="xs" className="items-center">
        <OverlayIconButton
            disabled={zoom <= minZoom}
            onClick={onZoomOut}
            aria-label={R.ZoomOut}
        >
            −
        </OverlayIconButton>
        <span className="min-w-[4ch] text-center text-sm text-white/80">
            {zoom === 1 ? R.FitToScreen : `${Math.round(zoom * 100)}%`}
        </span>
        <OverlayIconButton
            disabled={zoom >= maxZoom}
            onClick={onZoomIn}
            aria-label={R.ZoomIn}
        >
            +
        </OverlayIconButton>
    </HorizontalContainer>
);
